module.exports = __webpack_public_path__ + "img/cww_02.1943a1fd.jpg";